import React from 'react';
import styled from 'styled-components';
import { skeletonAnimation } from '~/App/shared/components/Skeletons';

interface StyledProps {
  chipWidth?: number;
}

const StyledSkeletonChip = styled.div<StyledProps>`
  height: 2.2rem;
  width: ${({ chipWidth }) => chipWidth}rem;
  ${skeletonAnimation}
  border-radius: 30px;
`;

function ChipSkeletonLoader() {
  function generateRandomNr(max: number, min: number): number {
    return Math.random() * (max - min) + min;
  }

  const chipWidth = generateRandomNr(10, 5);

  return (
    <StyledSkeletonChip chipWidth={chipWidth} data-testid="skeleton-chip" />
  );
}

export default ChipSkeletonLoader;
